<mb-accelerator #accelerator color="notification">
  <mb-icon icon="info"></mb-icon>
  <mb-accelerator-title i18n="@@users_views_x_es_muy_visitado"
    >¡{{ nameHotel }} es muy visitado!</mb-accelerator-title
  >
  <mb-accelerator-description
    i18n="@@users_views_hay_x_personas_mas_mirando_este_alojamiento"
    >Hay {{ usersViews }} personas más mirando este
    alojamiento</mb-accelerator-description
  >
</mb-accelerator>
